import type { ReactNode } from 'react';
import { cn } from '@wolfejs/ui/utils/classnames';

export type CartLineItemTitleProps = {
  className?: string;
  children: ReactNode;
};

export const CartLineItemTitle = ({ className, children }: CartLineItemTitleProps) => {
  return <div className={cn('', className)}>{children}</div>;
};
